const ListTypes = {
  BIN: 'bin',
  CUSTOMER_EMAIL: 'customer_email',
  CUSTOMER_ID: 'customer_id',
  CUSTOMER_IP: 'customer_ip',
  CUSTOMER_ZIP_CODE: 'customer_zip_code',
  PRODUCT_SKU: 'product_sku',
};

module.exports = ListTypes;
